import { usePaginatedApi } from "../../../swr/useApi";
import { adminLoyaltyService } from "../../api_client";
import type { AdminLoyaltyTransactionDto, LoyaltyPointsQueryDto } from "../../../api";

export function useAdminLoyaltyTransactions(query?: LoyaltyPointsQueryDto) {
  return usePaginatedApi<AdminLoyaltyTransactionDto, LoyaltyPointsQueryDto>({
    key: "admin-loyalty-transactions",
    serviceMethod: async (q) =>
      adminLoyaltyService.getAllTransactions(q) as never,
    query,
  });
}
